import script from "./Race2026.vue?vue&type=script&setup=true&lang=js"
export * from "./Race2026.vue?vue&type=script&setup=true&lang=js"

import "./Race2026.vue?vue&type=style&index=0&id=07d761e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d761e6"]])

export default __exports__